import Cookies from 'js-cookie';
import { removeTrailingSlash } from '../url';

export const YAKIT_FORCE_SET_PREVIEW_COOKIE_NAME = 'yakit_force_set_preview';

const COOKIE_OPTIONS = { path: '/', sameSite: 'none', secure: true };

export const getPreviewCookie = (): string => Cookies.get(YAKIT_FORCE_SET_PREVIEW_COOKIE_NAME) || '';

export const setPreviewCookie = (value: string | undefined) => {
    if (value) {
        Cookies.set(YAKIT_FORCE_SET_PREVIEW_COOKIE_NAME, value, COOKIE_OPTIONS);
    } else {
        Cookies.remove(YAKIT_FORCE_SET_PREVIEW_COOKIE_NAME, COOKIE_OPTIONS);
    }
};

export const normalizePreviewUrl = (url: string): string => {
    if (!url) {
        return '';
    }

    if (url.endsWith('/static/preview.js')) {
        return url;
    }

    return `${removeTrailingSlash(url)}/static/preview.js`;
};
